// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".main_cw6I_0 .content_bAuM4A {\n  position: relative;\n  display: flex;\n  justify-content: space-between;\n  height: 100%;\n  padding-top: 60px;\n}\n", "",{"version":3,"sources":["webpack://./src/App.less"],"names":[],"mappings":"AAAA;EAGI,kBAAA;EACA,aAAA;EACA,8BAAA;EACA,YAAA;EACA,iBAAA;AADJ","sourcesContent":[".main {\n  // height: 100%;\n  .content {\n    position: relative;\n    display: flex;\n    justify-content: space-between;\n    height: 100%;\n    padding-top: 60px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"main": "main_cw6I_0",
	"content": "content_bAuM4A"
};
export default ___CSS_LOADER_EXPORT___;
